export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"},{"charset":"utf-8"},{"name":"msapplication-TileColor","content":"#F05252"},{"name":"theme-color","content":"#F05252"}],"link":[{"rel":"preconnect","href":"//web.cmp.usercentrics.eu"},{"rel":"preconnect","href":"//privacy-proxy.usercentrics.eu"},{"rel":"preload","as":"script","href":"//privacy-proxy.usercentrics.eu/latest/uc-block.bundle.js"},{"rel":"preload","as":"style","href":"/fonts/css/fa.min.css","onload":"this.onload=null;this.rel='stylesheet'"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/favicon/apple-touch-icon.png"},{"rel":"shortcut icon","href":"/favicon/favicon.ico"},{"rel":"manifest","href":"/favicon/site.webmanifest"}],"style":[],"script":[{"src":"https://web.cmp.usercentrics.eu/ui/loader.js","id":"usercentrics-cmp","data-settings-id":"-MtBBOI221yiuK","async":true},{"src":"https://privacy-proxy.usercentrics.eu/latest/uc-block.bundle.js","type":"application/javascript"}],"noscript":[],"charset":"utf-8","viewport":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"}

export const appPageTransition = false

export const appLayoutTransition = false

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"